import { render } from "./mainImage.vue?vue&type=template&id=63ae2b98"
import script from "./mainImage.vue?vue&type=script&lang=js"
export * from "./mainImage.vue?vue&type=script&lang=js"

import "./mainImage.vue?vue&type=style&index=0&id=63ae2b98&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__